import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66565716"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breeding-manager-admin" }
const _hoisted_2 = {
  key: 0,
  class: "linked-users-empty"
}
const _hoisted_3 = {
  key: 1,
  class: "linked-users"
}
const _hoisted_4 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      type: "primary",
      loading: _ctx.isLoading,
      onClick: _ctx.loadManagers
    }, {
      default: _withCtx(() => [
        _createTextVNode(" 一覧を更新 ")
      ]),
      _: 1
    }, 8, ["loading", "onClick"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.managers,
      style: {"width":"100%","margin-top":"16px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "displayName",
          label: "飼養管理者名",
          "min-width": "160"
        }),
        _createVNode(_component_el_table_column, {
          label: "系統区分",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.channelTypeLabel[row.channelType]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "セルフ閲覧",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.selfServiceEnabled ? '有効' : '無効'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "紐付けユーザー",
          "min-width": "300"
        }, {
          default: _withCtx(({ row }) => [
            (row.users.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "-"))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.users, (user) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: user.userId,
                      class: "user-row"
                    }, [
                      _createElementVNode("span", {
                        class: "user-label",
                        title: _ctx.formatUserLabel(user)
                      }, _toDisplayString(_ctx.formatUserLabel(user)), 9, _hoisted_4),
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "danger",
                        link: "",
                        class: "unlink-button",
                        onClick: ($event: any) => (_ctx.unlinkUser(row.id, user.userId))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 解除 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  }), 128))
                ]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "280"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.selectedUserByManager[row.id],
              "onUpdate:modelValue": ($event: any) => ((_ctx.selectedUserByManager[row.id]) = $event),
              filterable: "",
              placeholder: "ユーザーを選択",
              style: {"width":"100%"},
              teleported: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: user.id,
                    label: _ctx.formatUserLabel(user),
                    value: user.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              style: {"margin-top":"8px"},
              disabled: !_ctx.selectedUserByManager[row.id],
              onClick: ($event: any) => (_ctx.linkUser(row.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 紐付け ")
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ]))
}